<template>
  <div class="d-flex-row lg-row-to-col justify-start exptra_options t-white">
    <div class="d-flex-row" v-if="options.includes('server')">
      <drop-down
        :label="$t('missed.region')"
        :item-key="'server'"
        :drop-items="keyedServers"
        :placeholder="'Select a Region'"
        :select-drop-item="selectItem"
        :selected-item="checkoutStore.getSelectedServer?.value"
      />
    </div>
    <div class="d-flex-row" v-if="options.includes('mode')">
      <drop-down
        :label="$t('missed.mode')"
        :item-key="'mode'"
        :drop-items="keyedModes"
        :placeholder="'Select Mode'"
        :select-drop-item="selectItem"
        :selected-item="checkoutStore.getPackExtraOptions['mode']"
      />
    </div>
  </div>
</template>

<script>
import DropDown from "../../../custom/DropDown.vue";

export default {
  data() {
    return {};
  },
  components: {
    DropDown,
  },

  methods: {
    selectItem(key, value) {
      if (key === "server") {
        this.checkoutStore.setServer(value);
        return;
      }
      this.checkoutStore.setPackExtraOptions({
        [key]: parseInt(value),
      });
    },
  },

  computed: {
    keyedServers() {
      const servers = this.getGame.servers;

      if (!servers) {
        return [];
      }

      return servers.reduce((acc, value) => {
        return { ...acc, [value.id]: value.title };
      }, {});
    },
    keyedModes() {
      const currentLp = this.getGamePack?.pack_extra_options?.filter(
        (option) => option.description === "queue"
      );

      if (!currentLp) {
        return [];
      }

      return currentLp.reduce((acc, value) => {
        return { ...acc, [value.id]: value.title };
      }, {});
    },
  },

  props: {
    options: {
      default: ["server"],
    },
  },
  setup() {
    const { getGame, getGamePack } = useGameStore();

    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
